import React, { Component } from "react";
import { Tank } from "@learningblocks/storybook-components";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../../Dialogs/toast/Toast";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";

const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  },
  BALANCED: {
    title: "Balanced!",
    message: "Looks balanced."
  },
  NOT_BALANCED: {
    title: "Not balanced!",
    message: "Distribute the tubes evently to balance the centrifuge."
  },
  // WRONG_NUMBER_TUBES: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of tubes."
  // },
  // WRONG_NUMBER_ROTORS: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of rotors."
  // },
  NOT_ALLOWED_CENTRIFUGE_RUNNING: {
    title: "Centrifuge running!",
    message: "Operation not avaliable while centrifuge running."
  },
};

export class Graphics extends Component {
  render() {
    return (
      <Tank
        id={this.props.id}
        numberOfPlants={this.props.numberOfPlants}
        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
      />
    );
  }
}
